import React from 'react'
import { Section, SectionLabel } from './Section'

export default class Lists extends React.PureComponent {
  render() {
    const { listsObject } = this.props
    const lists = listsObject && listsObject.lists

    return (
      <Section>
        {listsObject &&
          listsObject.state === 'fetched' && (
            <React.Fragment>
              <SectionLabel size="small" as="div">
                List memberships
              </SectionLabel>
              <ul>
                {lists &&
                  lists.map(list => {
                    return <li key={list.portalId}>{list.name}</li>
                  })}
              </ul>
            </React.Fragment>
          )}
      </Section>
    )
  }
}
